import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getTexts } from '@twnel/web-components';

const Body = ({
  width = undefined, height = undefined, sections, shouldRefresh, refreshData, redirect = true,
}) => {
  const texts = useSelector(getTexts);
  React.useEffect(() => {
    if (shouldRefresh) {
      refreshData();
    }
  }, [shouldRefresh, refreshData]);
  return (
    <Routes>
      {sections.map(({ path, Component, Fallback }) => (
        <Route
          key={`route:${path}`}
          path={`${path}/*`}
          element={(
            <Component
              width={width}
              height={height}
              fallback={Fallback ? <Fallback /> : null}
              texts={texts}
            />
          )}
        />
      ))}
      {/* Sin el rol del usuario no se sabe si la ruta es una sección de admin: se espera. */}
      {redirect ? (
        <Route path="*" element={<Navigate to={sections[0].path} replace />} />
      ) : null}
    </Routes>
  );
};

Body.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  sections: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    Fallback: PropTypes.elementType,
  })).isRequired,
  shouldRefresh: PropTypes.bool.isRequired,
  refreshData: PropTypes.func.isRequired,
  redirect: PropTypes.bool,
};

export default Body;
